export default "__VITE_ASSET__UB6F7A6s__"